import AnswerPanel from './answer_panel';

export default AnswerPanel;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/answer_panel/index.js